import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import BankAccountService from "services/lms/BankAccountService";
import PDCService from "services/lms/PDCService";
import dayjs from "dayjs";
import { notification } from "antd";

export const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
  bgChequeNumber: "",
  totalAmount: "",
  pdcType: "",
  bankName: "",
  showMessage: false,
  bankAccounts: [],
  pdcSinglelList: [],
  pdcMultiList: [],
  loanByKonsumenList: [],
  getCount: 0,
  timetablePDCList: [],
};

export const fetchBankAccounts = createAsyncThunk(
  "fetchBankAccounts",
  async (payload, thunkAPI) => {
    try {
      const response = await BankAccountService.getBankAccounts(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fatchPDCSingleSlice = createAsyncThunk(
  "fatchPDCSingleSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PDCService.getPDCSingle(payload);
      if (response.status === 200) {
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addPDCSingleSlice = createAsyncThunk(
  "addPDCSingleSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PDCService.addPDCSingle(payload);
      if (response.status === 200) {
        if (response?.data?.status === "Success") {
          notification.success({
            message: "Berhasil",
            description:
              response?.data?.message || "PDC berhasil disimpan.yyyy",
            duration: 4,
          });
          return response;
        } else {
          notification.error({
            message: "Gagal",
            description: response?.data?.message || "PDC gagal disimpan.",
            duration: 4,
          });
        }
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// PDC Multi loan slice can be added here following the same pattern

export const fatchPDCMultiSlice = createAsyncThunk(
  "fatchPDCMultiSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PDCService.getSearchListPDC(payload);
      if (response.status === 200) {
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fatchLoanByKonsumenSlice = createAsyncThunk(
  "fatchLoanByKonsumenSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PDCService.getLoanByKonsumen(payload);
      if (response.status === 200) {
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addPDCMultiSlice = createAsyncThunk(
  "addPDCMultiSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PDCService.addPDCmulti(payload);
      if (response.status === 200 && response?.data?.status === "Success") {
        return response;
      } else if (response.status === 200) {
        // Response 200 tapi proses gagal (mis. validasi backend)
        return rejectWithValue(response?.data);
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

//

const PDCSlice = createSlice({
  name: "Pdc",
  initialState,
  reducers: {
    resetStates: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      state.bankAccounts = [];
    },

    resetTimetable: (state) => {
      state.timetablePDCList = [];
      state.bgChequeNumber = "";
      state.totalAmount = "";
      state.pdcType = "";
      state.bankName = "";
    },

    updatePDCFields: (state, action) => {
      if (action.payload.bankName !== undefined)
        state.bankName = action.payload.bankName;
      if (action.payload.bgChequeNumber !== undefined)
        state.bgChequeNumber = action.payload.bgChequeNumber;
      if (action.payload.totalAmount !== undefined)
        state.totalAmount = action.payload.totalAmount;
      if (action.payload.pdcType !== undefined)
        state.pdcType = action.payload.pdcType;
    },

    generateMonthlyDates: (state, action) => {
      // Implementation for generating monthly dates
      const result = [];
      const start = dayjs(action?.payload?.startDate);
      console.log("action", action);

      for (let i = 0; i < action?.payload?.count; i++) {
        // .add(i, "month") otomatis menangani akhir bulan dengan benar
        result.push(start.add(i, "month").format("DD-MM-YYYY"));
      }
      state.timetablePDCList = result;
      state.bgChequeNumber = action?.payload?.bgChequeNumber || "";
      state.totalAmount = action?.payload?.totalAmount || "";
      state.pdcType = action?.payload?.pdcType || "";
      state.bankName = action?.payload?.bankName || "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBankAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBankAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bankAccounts = action.payload;
      })
      .addCase(fetchBankAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // fatchPDCSingleSlice
      .addCase(fatchPDCSingleSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fatchPDCSingleSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pdcSinglelList = action.payload?.data?.data;
        state.getCount = action.payload.count;
      })
      .addCase(fatchPDCSingleSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // addPDCSingleSlice
      .addCase(addPDCSingleSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addPDCSingleSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess =
          action.payload?.data?.status == "Success" ? true : false;
        state.message =
          action.payload?.data?.message || "PDC added successfully!";
      })
      .addCase(addPDCSingleSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // fatchPDCMultiSlice
      .addCase(fatchPDCMultiSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fatchPDCMultiSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pdcMultiList = action.payload?.data?.data;
        state.getCount = action.payload.count;
      })
      .addCase(fatchPDCMultiSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // addPDCMultiSlice
      .addCase(addPDCMultiSlice.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(addPDCMultiSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message =
          action.payload?.data?.message || "PDC Multi added successfully!";
        notification.success({
          message: "Berhasil",
          description:
            action.payload?.data?.message || "PDC Multi berhasil disimpan.",
          duration: 4,
        });
      })
      .addCase(addPDCMultiSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.payload?.message || action.payload;
        notification.error({
          message: "Gagal",
          description:
            action.payload?.message || "PDC Multi gagal disimpan.",
          duration: 4,
        });
      })
      // fatchLoanByKonsumenSlice
      .addCase(fatchLoanByKonsumenSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fatchLoanByKonsumenSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loanByKonsumenList = action.payload?.data?.data;
        state.getCount = action.payload.count;
      })
      .addCase(fatchLoanByKonsumenSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStates,
  resetTimetable,
  generateMonthlyDates,
  updatePDCFields,
} = PDCSlice.actions;

export default PDCSlice.reducer;
